import createKeys from '../../utilities/createKeys'

const Keys = createKeys('SPLIT_PAYMENT', ['ORDER_ITEMS', 'ORDER_ACCOUNTS'])

export default Keys
